import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import About from './AboutArea';
import FunFact from './FunFactArea';
import Service from './ServiceArea';
import Work from './WorkArea';
import Testimonial from './TestimonialArea';
import Newsletter from '../../components/Newsletter';
import Team from './TeamArea';

const AboutMain = () => {
  return (
    <main>
      <Breadcrumb title="About us" />
      <About />
      <FunFact />
      <Service />
      <Work />
      <Testimonial />
      <Newsletter />
      <Team />
    </main>
  );
};

export default AboutMain;
